import { useMemo } from 'react'

//* HOC's
import { withDataContext } from 'context'

//* Components
import Page from 'components/common/Page'
import Anchor from 'components/layouts/Anchor'

const PrivacyPolicy = ({ pages, pageParams, selectedLang }) => {
	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

	return (
		<Page meta={pageData?.meta} transparentHeader={pageParams.transparentHeader && !pageData}>
			{pageData && <Anchor isPrivacy={true} {...pageData.components?.[0].data} pageId={pageData.id} type={pageData.type} />}
		</Page>
	)
}

export default withDataContext(PrivacyPolicy, ['pages'])
